import { ArrowUpRight, Instagram, MapPin, Phone } from "lucide-react";
import { INSTAGRAM, LOCATION, PHONE_DISPLAY, PHONE_TEL, WA_DEFAULT } from "../data/site";
import { Reveal } from "./Reveal";

export const ConsultCTA = ({
    title = "Book a Consultation",
    text = "Does your child or family member experience difficulties related to speech, language, communication, fluency, or voice? Take the first step toward better communication with professional guidance and individualized therapy support.",
}) => (
    <section className="px-5 py-16 md:px-8 md:py-24" data-testid="consult-cta-section">
        <Reveal>
            <div className="relative mx-auto max-w-6xl overflow-hidden rounded-[2.5rem] bg-navy px-6 py-14 text-center md:px-16 md:py-20">
                <div
                    className="pointer-events-none absolute -left-24 -top-24 h-80 w-80 rounded-full opacity-30 blur-3xl"
                    style={{ background: "radial-gradient(circle, #72CFC4 0%, transparent 70%)" }}
                />
                <div
                    className="pointer-events-none absolute -bottom-24 -right-24 h-80 w-80 rounded-full opacity-25 blur-3xl"
                    style={{ background: "radial-gradient(circle, #F4A896 0%, transparent 70%)" }}
                />
                <h2 className="relative font-jakarta text-3xl font-extrabold tracking-tight text-cream sm:text-4xl lg:text-5xl">
                    {title}
                </h2>
                <p className="relative mx-auto mt-5 max-w-2xl text-base leading-relaxed text-cream/70 md:text-lg">
                    {text}
                </p>
                <div className="relative mt-9 flex flex-wrap items-center justify-center gap-x-8 gap-y-4 text-sm font-semibold text-cream/85">
                    <a href={PHONE_TEL} data-testid="cta-phone-link" className="flex items-center gap-2 transition-colors hover:text-peach">
                        <Phone size={16} className="text-aqua" /> Call / WhatsApp: {PHONE_DISPLAY}
                    </a>
                    <span className="flex items-center gap-2">
                        <MapPin size={16} className="text-aqua" /> {LOCATION}
                    </span>
                    <span className="flex items-center gap-2">
                        <Instagram size={16} className="text-aqua" /> Instagram: {INSTAGRAM}
                    </span>
                </div>
                <div className="relative mt-10 flex flex-wrap items-center justify-center gap-4">
                    <a
                        href={WA_DEFAULT}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="cta-book-session-btn"
                        className="group inline-flex items-center gap-2 rounded-full bg-peach px-8 py-4 font-jakarta text-sm font-bold text-navy shadow-xl shadow-peach/20 transition-all duration-300 hover:-translate-y-1 hover:bg-peach-deep hover:text-cream"
                    >
                        Book Your Session Today
                        <ArrowUpRight size={17} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </a>
                    <a
                        href={PHONE_TEL}
                        data-testid="cta-call-btn"
                        className="inline-flex items-center gap-2 rounded-full border border-cream/25 px-8 py-4 font-jakarta text-sm font-bold text-cream transition-all duration-300 hover:-translate-y-1 hover:border-aqua hover:text-aqua"
                    >
                        <Phone size={16} /> Call Now
                    </a>
                </div>
            </div>
        </Reveal>
    </section>
);
